
import Vue from "vue"
import { mapActions, mapState } from "vuex"
import ActionDialog from "@/components/ActionDialog.vue"
import ClubsForm from "./ClubsForm.vue"

export default Vue.extend({
  name: "ClubsEditDialog",

  components: {
    ActionDialog,
    ClubsForm
  },

  props: {
    shown: { type: Boolean, default: false },
    club: { type: Object, required: true }
  },

  data: function() {
    return {
      visible: this.shown,
      form: {}
    }
  },

  computed: mapState("clubs", {
    clubsStateEditOneIsLoading: "editOneIsLoading"
  }),

  watch: {
    visible(visible): void {
      this.$emit("update:shown", visible)
    },
    shown(visible): void {
      this.visible = visible
    },
    club: {
      immediate: true,
      handler(data): void {
        this.form = { ...data }
      }
    }
  },

  methods: {
    ...mapActions("clubs", {
      clubsActionsEditOne: "editOne"
    }),

    submit(): void {
      this.$refs.clubsForm.submit(async () => {
        try {
          await this.clubsActionsEditOne(this.form)
          this.$success(this.$t("clubsActionsEditOneSuccess", {
            clubsName: this.form.name
          }))
          this.close()
        } catch(e) {
          this.$error(e.message)
        }
      })
    },

    close(): void {
      this.visible = false
    }
  }
})
